import useFocusTrap from './useFocusTrap';

export default useFocusTrap;